import React, { useEffect, useRef } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import * as echarts from "echarts";
import Styles from "../Reports.module.scss";
import { LoggingHandler } from "../../../contexts/logging/LoggingContext";
import { useTheme } from "../../../contexts/Theme";

interface ChartProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options: any;
}

interface ChartActions {
    rerender: () => void;
}
export default React.forwardRef((props: ChartProps, reference: React.ForwardedRef<ChartActions>) => {
    const ref = React.createRef<HTMLDivElement>();
    const chartRef = useRef<echarts.ECharts>();

    const theme = useTheme();
    useEffect(() => {
        chartRef.current?.resize();
        chartRef.current?.updateLabelLayout();
    }, [theme.getTheme()]);

    useEffect(() => {
        if (!ref.current) {
            return;
        }

        const chart = echarts.init(ref.current);
        if (chartRef) {
            // eslint-disable-next-line no-param-reassign
            chartRef.current = chart;
        }
        chart.setOption(props.options);

        const handler = () => {
            chart.resize();
        };
        let observer: ResizeObserver | undefined;
        if (ref.current?.parentElement) {
            const parent = ref.current.parentElement;
            observer = new ResizeObserver(() => {
                LoggingHandler.instance.nextTick(async () => {
                    chart.resize();
                });
            });
            observer.observe(parent);
            ref.current.style.height = `100%`;
            ref.current.style.width = `100%`;
        }

        window.addEventListener("resize", handler);

        const actionsHandler: ChartActions = {
            rerender: () => {
                chart.resize();
            },
        };

        if (typeof reference === "function") {
            reference(actionsHandler);
        } else if (reference != null) {
            // eslint-disable-next-line no-param-reassign
            reference.current = actionsHandler;
        }

        // eslint-disable-next-line consistent-return
        return () => {
            window.removeEventListener("resize", handler);
            observer?.disconnect();
            // chart.dispose();
        };
    }, [ref.current, props.options]);

    return (
        <div ref={ref} data-testid={props.options.testId} className={`w-100 ${Styles["chart-1"]}`} />
    );
});
